const forms = {
  fr: {
    formId: process.env.REACT_APP_HUBSPOT_FORM_CONTACT_HQ_FR_ID,
    url: process.env.REACT_APP_HUBSPOT_FORM_CONTACT_HQ_FR_URL,
  },
};

export default forms;

